import _ from "lodash";
import { Masters } from "../../../atoms/masters.atom";

export const masterToOptions = (
  key: string,
  master: Masters,
  disabled: string[] | undefined = [],
  sort?: boolean
) => {
  const options =
    master[key]?.map(({ key, value }) => ({
      value: key,
      label: value,
      disabled: disabled.includes(key),
    })) ?? [];
  return sort ? _.sortBy(options, "label") : options;
};
